export default __webpack_public_path__ + "static/tornado_sim_example-d5f1b879ebbca698930e04096cb1ae5e.mp4";